import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent {
  @Input() size = 24;
  @Input() color = '#000';
}
